import { useEffect } from "react";
import { signal } from "@preact/signals-react";

import PanelDesk from "./panel/PanelDesk";
import { useGlobal } from "storev2/globalStore";
import proxy from "api/proxy";
import FrontTabs from "./FrontTabs";
import { tabs } from "./tabs";
// import SearchBar from "componentsv2/widgets/SearchBar";

const selectedTab = signal("house_status");
const globalSearch = signal("");
const component = signal(tabs.house_status.Component);

function FrontdeskScreen() {
  const { setCustomStore } = useGlobal();

  async function getLocations() {
    const fieldsNames = ["id", "name"];
    const orderBy = [["name", "ASC"]];
    const dom = [];

    const { data } = await proxy.search(
      "hotel.location",
      dom,
      fieldsNames,
      null,
      orderBy,
    );
    return data;
  }

  useEffect(() => {
    async function setData() {
      const locations = await getLocations();
      setCustomStore({ locations });
    }
    setData();
  }, []);

  function handleSearch(query) {
    globalSearch.value = query;
    console.log("Search query:", query);
  }

  const currentTab = tabs[selectedTab.value];
  return (
    <div className="md:flex w-full md:pl-7 md:pr-2">
      <div className="md:w-5/6 md:pt-4">
        <div className="flex justify-between max-md:px-5">
          <div className="flex text-xl max-md:mx-auto md:text-4xl  text-neutral-500 gap-x-2">
            <span className="font-light">My Frontdesk</span>
            <span className="font-light mx-1">|</span>
            <span className="font-bold">{currentTab.name}</span>
          </div>
        </div>
        <FrontTabs
          selectedTab={selectedTab}
          tabs={tabs}
          component={component}
          globalSearch={globalSearch}
        />
      </div>
      <PanelDesk />
    </div>
  );
}

export default FrontdeskScreen;
